export default __webpack_public_path__ + "static/media/the-best-of-both-worlds.cbe7e9c7.png";